import { render, staticRenderFns } from "./result.vue?vue&type=template&id=7724b1f2&scoped=true"
import script from "./result.vue?vue&type=script&lang=ts"
export * from "./result.vue?vue&type=script&lang=ts"
import style0 from "./result.vue?vue&type=style&index=0&id=7724b1f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724b1f2",
  null
  
)

export default component.exports